module.exports = __webpack_public_path__ + "img/frame88.edcd91d9.svg";